import { createAsyncThunk } from "@reduxjs/toolkit";
import plansApi from "api/planApi";
import { formatQueryParams } from "helpers/format";

export const getPlans = createAsyncThunk("Plans", async (params: any = {}) => {
  try {
    const response = await plansApi.getPlans(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const createPlanPurchaseSucceeded = async (data: any = {}) => {
  try {
    const response = await plansApi.plansPurchaseSucceeded(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const createPlan = async (data: any = {}) => {
  try {
    const response = await plansApi.postPlan(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const updatePlan = async (id: string | number, data: any = {}) => {
  try {
    const response = await plansApi.putPlan(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
